import ExactAnswerModel from '../exactAnswer/index.model.js';
import RelatedQuestionsModel from '../relatedQuestions/index.model.js';
const model = {
    name: 'Questions',
    properties: {
        keyphrase: {},
        exact_answer: { type: 'model', model: ExactAnswerModel },
        related_questions: { type: 'model', model: RelatedQuestionsModel },
    },
};
export default model;
